import { DATE_FORMAT_PICKER, MAX_FORMULA_INT } from 'src/config';
import * as Yup from 'yup';
import { formatUrl } from 'src/utils/misc';
import moment from 'moment';
import { IncidentInput } from 'src/graphql/_generated';

export const incidentValidationSchema = Yup.object({
  ref: Yup.string().nullable().max(100, 'Max 100 characters'),
  name: Yup.string().required('Required').max(200, 'Max 200 characters'),
  severity: Yup.string().nullable().max(100, 'Max 100 characters'),
  source: Yup.string()
    .nullable()
    .max(200, 'Max 200 characters')
    // @ts-ignore
    .test('source', 'Must be a valid url', (source) => {
      if (!source) return true;
      return formatUrl(source);
    }),
  description: Yup.string().nullable().max(2000, 'Max 2000 characters'),
  dateOfIncident: Yup.string()
    .test('date', 'Invalid Date', (date) => {
      if (!date) return true;
      if (typeof date === 'string') {
        return moment(date, [DATE_FORMAT_PICKER, moment.ISO_8601]).isValid();
      }
      return false;
    })
    .nullable(),
  impact: Yup.string().nullable().max(2000, 'Max 2000 characters'),
  financialImpactUpper: Yup.number()
    .nullable()
    .min(1, 'Minimum is 1')
    .max(MAX_FORMULA_INT, `Maximum number is ${MAX_FORMULA_INT}`),
  financialImpactLower: Yup.number()
    .nullable()
    .min(1, 'Minimum is 1')
    .max(MAX_FORMULA_INT, `Maximum number is ${MAX_FORMULA_INT}`),
  incidentType: Yup.string()
    .nullable()
    .test('type', 'Invalid type', (type) => {
      if (!type) return true;
      return ['Near miss', 'Incident'].includes(type);
    }),
});

export const incidentInitialValues: IncidentInput = {
  id: null,
  ref: '',
  name: '',
  source: null,
  description: null,
  dateOfIncident: null,
  owner: null,
  impact: null,
  financialImpactUpper: null,
  financialImpactLower: null,
  incidentType: null,
};
